import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Dropdown } from '@zocdoc-frontend-common/components-dropdown';

class BaseInsurancePlanDropdownView extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
        onClick: PropTypes.func,
        planId: PropTypes.string,
        plans: PropTypes.array.isRequired,
    };

    static defaultProps = {
        onClick: noop,
    };

    render() {
        const { isLoading, planId, plans } = this.props;

        if (isLoading) {
            return (
                <Dropdown disabled options={plans} placeholder="Loading..." />
            );
        }

        return (
            <Dropdown
                data-test="plans-dropdown"
                data-uem-id="plans-dropdown"
                onChange={this.handleChange}
                onClick={this.handleClick}
                options={plans}
                placeholder="Choose Plan"
                selected={planId}
            />
        );
    }

    handleChange = e => this.props.onChange(e.target.value);
    handleClick = e => this.props.onClick(e.target.value);
}

export const InsurancePlanDropdownView = BaseInsurancePlanDropdownView;
